module.exports = ['$scope', '$state', '$interval', 'CanDoServices', 'ngDroUAA', '$translate', 'ngDroUtilsNotify',
    function ($scope, $state, $interval, CanDoServices, ngDroUAA, $translate, ngDroUtilsNotify) {

        /*
         * Configs
         */

        // Informazioni per la parametrizzazione della direttiva navabar-title.
        //$scope.infoTitle = {icon: 'fa-user fa-fw', message: 'jdro_person.info.title'};

        // Informazioni per la parametrizzazione della direttiva button-add.
        $scope.infoAdd = {icon: 'fa-user fa-fw', message: 'jdro_person.add'};

        // sui mobile, si perde il focus ad ogni chiamata. Allora uso debounce
        $scope.inputOptions = {debounce: 500};

        /*
         * Methods
         */
        $scope.remove = function (person) {
            messageUser = $translate.instant('jdro_person.confirm_delete_this_user'); // mai utilizzato in pratica perche il successivo if è sempre true

            if (person.firstName && person.lastName) {
                messageUser = person.firstName.sformat(person.lastName);
            }
            options = {
                success: function () {
                    ngDroUAA.Person.delete(person.id)
                            .then(function () {
                                // lo elimino anche da person
                                $scope.persons = $scope.persons.filter(function (item) {
                                    return item.id !== person.id;
                                });
                                ngDroUtilsNotify.deleteSuccess(messageUser);
                            })
                            .catch(function (err) {
                                ngDroUtilsNotify.deleteError(messageUser, err);
                            });
                },
                itemTitle: messageUser,
                headTitle: 'jdro_person.confirm_delete'
            };
            ngDroUtilsNotify.confirmDelete(options);
        };

        $scope.add = function () {
            $state.go('uaa-module-person-add');
        };

        $scope.edit = function (resource) {
            $state.go('uaa-module-person-edit', {id: resource.id});
        };
        
        // chiamata per caricare gli utenti, utilizza il pageable e query
        $scope.loadMore = function () {

            function _appendResult(data) {
            
                $scope.persons = $scope.persons ? $scope.persons.concat(data.content) : data.content;
                pageable.pageNumber = pageable.pageNumber + 1;

                if (data.totalPages <= pageable.pageNumber) {
                    if (pageable.pageNumber > 1) {
                        ngDroUtilsNotify.success(null, 'jdro_person.stop_paging');
                    }
                    $scope.hideLoadMore = true;
                    ignoreLoadMore = true;
                }
            }

            if (!query && !ignoreLoadMore) {
                //caso no ricerca
                ngDroUAA.Person.findAll(pageable).then(function (response) {
                    _appendResult(response.data);
                }).catch(function (err) {
                    ngDroUtilsNotify.error(null, 'jdro_person.error.find_all', null, err);
                });
            } else if (query && query.length >= 3 && !ignoreLoadMore) {
                // caso ricerca                
                ngDroUAA.Person.findAll(pageable, query).then(function (response) {
                    _appendResult(response.data);
                    if (pageable.pageNumber === 1) {    // workaround per non far perdere il focus quando digita
                        var intervaL = $interval(function () {
                            $("#find-input").focus();
                        }, 500, 1);
                    } else {
                        $("#find-input").blur();
                    }
                });
            }
        };

        // callback di input, chiamata quando digito.
        $scope.loadItems = function (typed) {
            query = typed;
            pageable.pageNumber = 0;
            if (typed.length === 0) {
                delete query; // perchè in loadMore !query non fa differenza tra undefined e ""
                cleanPersons();
            }
            cleanPersons();
            $scope.loadMore();
        };

        // funzione che svuota la tabella delle persone
        function cleanPersons() {
            $scope.persons = [];
            pageable.pageNumber = 0;
            $scope.hideLoadMore = false;
            ignoreLoadMore = false;
        }
        
        /*
         * Init
         */
        
        $scope.persons;    
        var pageable = {
            pageNumber: 0,
            size: 100,
            sorting: 'id',
            order: 'asc'
        };

        $scope.pageable_size = pageable.size;

        var query; // mi tengo il valore dell'ultima ricerca
        var ignoreLoadMore = false;

        //   $scope.loadMore();  

        // Ottengo i permessi per le operazioni Create
        CanDoServices.canDo("PERSON", ["CREATE"]).then(function (perms) {
            $scope.jdroPerms = perms;
        });

    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/person/personList/personListCtrl.js
// module id = 431
// module chunks = 0